import getEnv from "./getEnv";

const config = {
  agrupaCargasPeloAgrupamento: getEnv('REACT_APP_CARGAS_POR_AGRUPAMENTO') === 'true',
  motivosDevolucaoPelaApi: getEnv('REACT_APP_MOTIVO_DEVOLUCAO_PELA_API') === 'true',
  mostraCargasFinalizadas: getEnv('REACT_APP_MOSTRA_CARGAS_FINALIZADAS') === 'true',
  /** Se true, permite à pessoa rotacionar a foto no modal antes de confirmar. Se false, salva direto (só correção EXIF). */
  redimensionarFotoCanhoto: getEnv('REACT_APP_REDIMENSIONAR_FOTO_CANHOTO') === 'true',
  /** Se true, na devolução (cliente recusou) exige apenas a foto 2. Se false, mantém comportamento legado (exige canhoto). */
  devolucaoExigirApenasFoto2: getEnv('REACT_APP_DEVOLUCAO_EXIGIR_APENAS_FOTO2') === 'true',
  /** Se true, o motivo da devolução é digitado em texto livre em vez de escolhido na lista. */
  motivoDevolucaoTextoLivre: getEnv('REACT_APP_MOTIVO_DEVOLUCAO_TEXTO_LIVRE') === 'true',
  /** Se true, exibe na lista de cargas o botão que leva à tela Documentos (informe de rendimentos, etc.). */
  mostraMenuDocumentos: getEnv('REACT_APP_MOSTRA_MENU_DOCUMENTOS') === 'true',
  /** Se true, lista e finaliza por entrega (um card por cliente com N notas) em vez de um card por nota fiscal. */
  listarPorEntrega: getEnv('REACT_APP_LISTAR_POR_ENTREGA') === 'true',
}

export default config;